import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider, useMutation, useQuery, useSuspenseQuery, } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { isInfiniteQueryFactory, isQueryFactory, } from './BaseSdk.js';
export { useMutation, useSuspenseQuery };
function makeHookProxy() {
    return new Proxy({}, {
        get(_, prop) {
            const [, methodName] = prop.toString().match(/^use(.*)$/) || [];
            if (!methodName) {
                throw new Error(`Invalid hook name: ${prop.toString()}`);
            }
            const isLazy = methodName.endsWith('Lazy');
            let correctedMethodName = methodName.charAt(0).toLowerCase() + methodName.slice(1);
            if (isLazy) {
                correctedMethodName = correctedMethodName.slice(0, -4);
            }
            // queries
            if (correctedMethodName.startsWith('get') ||
                correctedMethodName.startsWith('adminGet')) {
                return (...args) => {
                    const sdk = useSdk();
                    const method = sdk[correctedMethodName];
                    if (isQueryFactory(method)) {
                        if (isLazy) {
                            return useQuery(method(...args));
                        }
                        return useSuspenseQuery(method(...args));
                    }
                    else if (isInfiniteQueryFactory(method)) {
                        return useSuspenseQuery(method(...args));
                    }
                    throw new Error(`Method ${correctedMethodName} starts with 'get' but is not a query or infinite query`);
                };
            }
            else {
                return () => {
                    const sdk = useSdk();
                    const method = sdk[correctedMethodName];
                    return useMutation(method);
                };
            }
        },
    });
}
export function hookifySdk() {
    return makeHookProxy();
}
const SdkContext = createContext(null);
export const SdkProvider = ({ children, value, }) => {
    return (_jsx(QueryClientProvider, { client: value.queryClient, children: _jsx(SdkContext.Provider, { value: value, children: children }) }));
};
export function useSdk() {
    const sdk = useContext(SdkContext);
    if (!sdk) {
        throw new Error('useSdk must be used within a SdkProvider');
    }
    return sdk;
}
//# sourceMappingURL=hooks.js.map